import axios from "axios";
import { auth } from "../firebase";
import { handleApiError } from "../utils/errorHandler";

const API_URL = process.env.REACT_APP_API_URL;

// Create shared axios instance with common configuration
const createApiClient = () => {
  const api = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Add auth token to requests
  api.interceptors.request.use(
    async (config) => {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor for error handling
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      console.log("error", error);

      // Check if this is an email verification error and we haven't already retried
      if (
        error.response?.status === 403 &&
        error.response?.data?.detail?.code === "EMAIL_NOT_VERIFIED" &&
        !originalRequest._retry
      ) {
        console.log("Retrying request due to email verification error");
        originalRequest._retry = true;

        try {
          const user = auth.currentUser;
          if (user) {
            // Refresh the user's data from Firebase
            await user.reload();

            // Force refresh the token to get updated claims
            const newToken = await user.getIdToken(true);
            originalRequest.headers.Authorization = `Bearer ${newToken}`;

            // Retry the original request
            return api(originalRequest);
          }
        } catch (refreshError) {
          // If refresh fails, log the error and reject the promise
          console.error("Token refresh failed:", refreshError);
          // Fall through to original error handling
        }
      }

      const customError = handleApiError(error);
      return Promise.reject(customError);
    }
  );

  return api;
};

// Export a singleton instance
export const apiClient = createApiClient();
